import LiveJoinWaitComponent from "./LiveJoinWaitComponent";

export default LiveJoinWaitComponent